<div class="p-5 text-center">
  <h3 style="font-size:xx-large;">
    Loading Error
  </h3>
  <p class="text-danger">
    <em>
      {{error}}
    </em>
  </p>
</div>